import { QueryParams } from './constants';

export class URLParams {
	params: URLSearchParams;

	constructor() {
		this.params = new URLSearchParams(window.location.search);
	}

	get code(): string | null {
		return this.params.get(QueryParams.code);
	}

	get state(): string | null {
		return this.params.get(QueryParams.state);
	}

	get bl(): string | null {
		return this.params.get(QueryParams.bl);
	}

	public isFromLogin = (): boolean => {
		return Boolean(this.bl === '1' && this.code && this.state);
	}
}